import Colors from "./Colors";


export default {
    Style: {},
    allStyles:{
        paraPrivilege:{
            colorMainColor:{
                color: Colors.allColors.paraPrivilege.mainColor
            },
            bgColorMain:{
                backgroundColor: Colors.allColors.paraPrivilege.mainColor
            },
            bgColorSecondary:{
                backgroundColor: Colors.allColors.paraPrivilege.secondaryColor
            },
            borderBottom:{
                borderBottom: "3px solid "+ Colors.allColors.paraPrivilege.mainColor
            },
            progtrckrdoing:{
                color: Colors.allColors.paraPrivilege.mainColor,
                borderBottom: "3px solid "+ Colors.allColors.paraPrivilege.mainColor
            }

        },

        universPharmacie:{
            colorMainColor:{
                color: Colors.allColors.universPharmacie.mainColor
            },
            bgColorMain:{
                backgroundColor: Colors.allColors.universPharmacie.mainColor
            },
            bgColorSecondary:{
                backgroundColor: Colors.allColors.universPharmacie.secondaryColor
            },
            borderBottom:{
                borderBottom: "3px solid "+ Colors.allColors.universPharmacie.mainColor
            },
            progtrckrdoing:{
                color: Colors.allColors.universPharmacie.mainColor,
                borderBottom: "3px solid "+ Colors.allColors.universPharmacie.mainColor
            }
        },

        pharmaCarte:{
            colorMainColor:{
                color:Colors.allColors.pharmaCarte.mainColor
            },
            bgColorMain:{
                backgroundColor: Colors.allColors.pharmaCarte.mainColor
            },
            bgColorSecondary:{
                backgroundColor: Colors.allColors.pharmaCarte.secondaryColor
            },
            borderBottom:{
                borderBottom: "3px solid "+ Colors.allColors.pharmaCarte.mainColor
            },
            progtrckrdoing:{
                color: Colors.allColors.pharmaCarte.mainColor,
                borderBottom: "3px solid "+ Colors.allColors.pharmaCarte.mainColor
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/styles/Styles.js